"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import { services } from "@/app/(site)/data/serviceData";
import Card from "../services/Card";

export default function PracticeAreas() {
  return (
    <section className="flex flex-col items-center justify-center w-full bg-primary/10 py-20 md:py-24">

      {/* Top section */}
      <div className="w-full px-6 md:px-15">
        <div className="w-full mx-auto flex flex-col lg:flex-row items-center lg:items-end justify-between gap-8 lg:gap-14">

          <div className="flex flex-col w-full lg:w-2/5 text-center lg:text-left">
            <h2 className="text-[30px] md:text-[38px] font-lora font-semibold leading-tight md:leading-snug">
              Our Strategic Legal Solutions, Tailored for You
            </h2>
          </div>

          <div className="w-full lg:w-3/5 flex items-end justify-center lg:justify-end">
            <p className="text-[18px] md:text-[20px] font-light w-full lg:w-[75%] leading-[28px] md:leading-[32px]">
              Our legal solutions are built around what matters most to you — protecting your business,
              your rights, and your future.
            </p>
          </div>

        </div>
      </div>

      {/* Services slider */}
      <div className="w-full pt-10 md:pt-15 pb-0 md:pb-20 px-2 md:pl-15">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          speed={1000}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          spaceBetween={15}
          slidesPerView={5}
          breakpoints={{
            320: { slidesPerView: 1.15, spaceBetween: 16 },
            480: { slidesPerView: 1.6, spaceBetween: 18 },
            640: { slidesPerView: 2, spaceBetween: 24 },
            1024: { slidesPerView: 3, spaceBetween: 28 },
            1280: { slidesPerView: 4, spaceBetween: 30 },
            1440: { slidesPerView: 4, spaceBetween: 30 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={service.slug} className="h-[300px] md:h-[500px]">
              <Card service={service} index={index + 1} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
